import ApiService from '@/apis/apiService'
import type { User } from '@/types/user'

interface SessionResponse {
  user: User | null
}

const show = async (): Promise<SessionResponse> => {
  const response = await ApiService.get<SessionResponse>('/api/sessions')
  return response.data
}

const create = async (email: string, password: string): Promise<SessionResponse> => {
  const response = await ApiService.post<SessionResponse>('/api/sessions', {
    user: { email, password },
  })
  return response.data
}

const destroy = async (): Promise<void> => {
  await ApiService.delete('/api/sessions')
}

export default { show, create, destroy }
